import React from "react";

const CSV = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="17.57" height="22.451" viewBox="0 0 17.57 22.451">
			<path
				id="icon-csv"
				d="M17.819,2H7V24.451H24.57V8.556ZM13.442,16.423a1.623,1.623,0,0,0,.461-.074l.1.806a1.967,1.967,0,0,1-.747.116c-1.258,0-1.859-1.039-1.859-2.436,0-1.861,1.031-2.585,1.99-2.585a1.334,1.334,0,0,1,.667.132l-.162.806a.952.952,0,0,0-.446-.1c-.541,0-1.031.467-1.031,1.691C12.411,15.961,12.857,16.423,13.442,16.423Zm1.779.848a2.192,2.192,0,0,1-.944-.2l.139-.827a1.888,1.888,0,0,0,.812.189c.454,0,.673-.233.673-.555,0-.36-.219-.536-.637-.806a1.662,1.662,0,0,1-.928-1.376,1.414,1.414,0,0,1,1.56-1.449,1.688,1.688,0,0,1,.776.175l-.154.827a1.176,1.176,0,0,0-.629-.168c-.41,0-.608.248-.608.513,0,.292.147.446.681.768a1.608,1.608,0,0,1,.894,1.413A1.487,1.487,0,0,1,15.221,17.271Zm3.954-.044H18.1l-1.1-4.934h1.06l.353,2.13c.088.528.191,1.136.255,1.714h.015c.065-.585.147-1.178.234-1.735l.336-2.109H20.3ZM17.737,8.833V2.976l5.826,5.857Z"
				transform="translate(-7 -2)"
				fill="#fff"
			/>
		</svg>
	);
};

export default CSV;
